import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { environment } from '../../environment/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.html',
  styleUrl: './login.scss',
  imports: [CommonModule, FormsModule, HttpClientModule],
})
export class Login {
  username = '';
  password = '';
  errorMessage = '';
  showPassword = false;

  constructor(private http: HttpClient, private router: Router) {}
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit(form: NgForm) {
    const payload = { username: this.username, password: this.password };

    this.http
      .post(`${environment.apiUrl}/api/auth/login`, payload, { withCredentials: true })
      .subscribe({
        next: () => {
          this.router.navigate(['/dasboard']);
        },
        error: (err) => {
          // Agrega manejo para el error 429
          if (err.status === 401) {
            this.errorMessage = 'Usuario o contraseña incorrectos';
          } else if (err.status === 429) {
            // ¡Aquí está el error del rate limiter!
            this.errorMessage = 'Demasiados intentos fallidos. Espere 15 minutos.';
          } else {
            this.errorMessage = 'Error del servidor. Intente más tarde.';
          }

          // Espera 3 segundos y reinicia
          setTimeout(() => {
            form.resetForm();
            this.errorMessage = '';
          }, 3000);
        },
      });
  }
}
